export default "__VITE_ASSET__N19YE1$R__"